import { Stack } from '@mui/material';
import { FC } from 'react';
import { ThemedSkeleton } from '@focuslee/shared-mini-app';
import { Page } from '../../Page';

export const CategoryQuestListSkeleton: FC = () => {
  return (
    <Page back insetEnabled={false}>
      <Stack direction="row" alignItems="center" justifyContent="center" gap={1} mt={1} mb={3}>
        <ThemedSkeleton variant="rectangular" width={30} height={30} sx={{ borderRadius: 2 }} />
        <ThemedSkeleton variant="text" width={150} height={28} />
      </Stack>
      <Stack px={2} direction="row" alignItems="flex-start" justifyContent="space-between" paddingBottom="10px" gap={1} borderBottom='1px solid var(--tg-theme-section-bg-color)'>
        <ThemedSkeleton variant="rectangular" width="60%" height={40} sx={{ borderRadius: '8px' }} />
        <ThemedSkeleton variant="rectangular" width="35%" height={40} sx={{ borderRadius: '8px' }} />
      </Stack>
      <Stack padding="10px" paddingBottom="150px" gap={1}>
        {Array.from({ length: 6 }).map((_, i) => (
          <ThemedSkeleton 
            key={i} 
            variant="rectangular" 
            width="100%" 
            height={70} 
            sx={{ borderRadius: '12px' }} 
          />
        ))}
      </Stack>
    </Page>
  );
};

